
import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  error: false,
  loading: false,
  loaded: false,
  multiRouter: {},
  isAssignPodRequestLoading: false,
  assignPodSuccess: false,
  assignPodFailure: false,
  successStatusMessage: '',
  errorStatusMessage: '',
  unClaimedPodSuccess: false,
  unClaimedPodFailure: false,
  isunClaimedPodRequestLoading: false
};
const initMultiRouterStart = (state, action) => {
  return updateObject(state, {
    error: false,
    loading: true,
    loaded: false,
    success: false,
    // successStatusMessage: '',
    // errorStatusMessage: '',
    unClaimedPodSuccess: false,
    unClaimedPodFailure: false,
    assignPodSuccess: false,
    assignPodFailure: false,
    isAssignPodRequestLoading: false,
  });
};

const setMultiRouter = (state, action) => {
  console.log('SETTING MULTI', action, state)
  return updateObject(state, {
    multiRouter: action.multiRouter,
    loading: false,
    loaded: true,

  });
};

const getMultiRouterFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const getMultiRouterSuccess = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: false,
  });
};




const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_MULTI_ROUTER_START:
      return initMultiRouterStart(state, action);
    case actionTypes.SET_MULTI_ROUTER:
      return setMultiRouter(state, action);
    case actionTypes.GET_MULTI_ROUTER_SUCCESS:
      return getMultiRouterSuccess(state, action);
    case actionTypes.GET_MULTI_ROUTER_FAILED:
      return getMultiRouterFailed(state, action);
    case actionTypes.ASSIGN_POD_REQUEST:
      return updateObject(state, {
        isAssignPodRequestLoading: true,
        assignPodSuccess: false,
        assignPodFailure: false,
        successStatusMessage: '',
        errorStatusMessage: ''
      });
    case actionTypes.ASSIGN_POD_SUCCESS:
      return updateObject(state, {
        isAssignPodRequestLoading: false,
        assignPodSuccess: true,
        assignPodFailure: false,
        successStatusMessage: action.message,
        errorStatusMessage: ''
      });
    case actionTypes.ASSIGN_POD_FAILED:
      return updateObject(state, {
        isunClaimedPodRequestLoading: false,
        assignPodSuccess: false,
        assignPodFailure: true,
        successStatusMessage: '',
        errorStatusMessage: action.message,
        isAssignPodRequestLoading: false,
      });
    case actionTypes.UNCLAIMED_POD_SUCCESS:
      return updateObject(state, {
        isunClaimedPodRequestLoading: false,
        unClaimedPodSuccess: true,
        unClaimedPodFailure: false,
        successStatusMessage: action.message,
        errorStatusMessage: ''
      });
    case actionTypes.UNCLAIMED_POD_REQUEST:
      return updateObject(state, {
        isunClaimedPodRequestLoading: true,
        unClaimedPodSuccess: false,
        unClaimedPodFailure: false,
        successStatusMessage: '',
        errorStatusMessage: ''
      });
    case actionTypes.UNCLAIMED_POD_FAILED:
      return updateObject(state, {
        isunClaimedPodRequestLoading: false,
        unClaimedPodSuccess: false,
        unClaimedPodFailure: true,
        successStatusMessage: '',
        errorStatusMessage: action.message
      });
    case actionTypes.RESET_MULTI_ROUTER_STATUS:
      return updateObject(state, {
        isunClaimedPodRequestLoading: false,
        unClaimedPodSuccess: false,
        unClaimedPodFailure: false,
        successStatusMessage: '',
        errorStatusMessage: '',
        assignPodSuccess: false,
        assignPodFailure: false,
        isAssignPodRequestLoading: false,
      });
    default:
      return state;
  }
};

export default reducer;
